var MobileDetect = require("mobile-detect");

const _converter = {
  downloadOnIpadChrome(b, fileName) {
    let r = "";
    let pre = "data:application/pdf;base64,";
    r = pre + b;
    let a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display:none";
    a.href = r;
    a.download = fileName;
    a.click();
  },
  previewOnIpadSafari(b, fileName) {
    let r = "";
    let pre = "data:application/pdf;base64,";
    r = pre + b;
    var anchorElement = document.createElement("a");
    anchorElement.href = r;
    anchorElement.target = "_self";
    anchorElement.download = fileName;
    var event = document.createEvent("MouseEvents");
    event.initEvent("click", true, false);
    anchorElement.dispatchEvent(event);
  },
  download(b, fileName) {
    let md = new MobileDetect(window.navigator.userAgent);
    let isiPad = md.is("iPad");
    let isSafari = md.is("Safari");
    let isChrome = md.is("Chrome");
    let blob = this.convert(b);
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, fileName);
    } else if (isiPad && isSafari) {
      this.previewOnIpadSafari(b, fileName);
    } else if (isiPad && isChrome) {
      this.downloadOnIpadChrome(b, fileName);
    } else {
      var url = (window.URL || window.webkitURL).createObjectURL(blob);

      var a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display:none";
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
    }
    return true;
  },
  convert(b) {
    const utf8Array = this.base64ToBuffer(b);
    return new Blob([new Uint8Array(utf8Array)]);
  },
  base64ToBuffer(str) {
    str = atob(str); // creates a ASCII string
    var buffer = new ArrayBuffer(str.length),
      view = new Uint8Array(buffer);
    for (var i = 0; i < str.length; i++) {
      view[i] = str.charCodeAt(i);
    }
    return buffer;
  },
};

export default _converter;
